import React from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import AppWrapper from './app-wrapper.jsx';

const posthogToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

const posthogOptions = {
  api_host: posthogHost,
  defaults: '2026-01-30',
  session_recording: {
    maskAllInputs: true,
  },
};

function Root() {
  if (!posthogToken) {
    return <AppWrapper />;
  }
  return (
    <PostHogProvider apiKey={posthogToken} options={posthogOptions}>
      <AppWrapper />
    </PostHogProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
